export default "__VITE_ASSET__764b55b0__"